'use client';

import { Tooltip } from '@mui/material';
import classnames from 'classnames';
import { usePathname, useRouter } from 'next/navigation';
import { HiPlus } from 'react-icons/hi';

import styles from './styles.module.scss';

type ButtonProps = {
  loading?: boolean;
  className?: string;
  disabled?: boolean;
};

export function CreateReportButtonComponent({ loading = false, className = '', disabled = false }: ButtonProps) {
  const { push } = useRouter();
  const pathname = usePathname();
  return (
    <Tooltip title="Criar reporte" placement="top" arrow>
      <button
        type="button"
        className={classnames(
          styles.buttonCreate,
          { [className]: className, [styles.disabled]: disabled },
          { [styles.none]: pathname.split('/')[1] === 'report' }
        )}
        onClick={() => push('/report')}
        disabled={loading ? true : disabled}
      >
        <HiPlus size={32} />
      </button>
    </Tooltip>
  );
}
